import React, { useEffect,useState } from 'react';
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import { getTemplateDetail, getDefaultList } from "../../../../utils/faqApi";

const CommonFaqTemplateWidget = ({selectedTemplate,isTemplateId,widgetId,faqTabData,refreshWidgetList }) => {
    //States
    const [apiData, setApiData] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [openIndexes, setOpenIndexes] = useState([]);

    const {
        is_website_frontend,
        is_show_display_category_title,
        is_open_first_question_by_default,
        is_multiple_active_question,
        widget_title,
        is_open_search_bar,
        sidebar_layout_type,
        accordion_icon_type,
        item_background_color,
        question_text_color,
        answer_text_color,
    } = faqTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/faq/temp-css/Faq.css`;
        if (widgetId) {
            link.setAttribute("faq-data-dynamic-css", "faq");
        } else {
            link.setAttribute("data-dynamic-css", "faq");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="faq"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    //Api Call
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (isTemplateId) {
                    const result = await getTemplateDetail(isTemplateId);
                    setApiData(result);
                } else if (widgetId) {
                    const result = await getSingleWidgetDetail(widgetId);
                    setApiData(result);
                } else {
                    const result = await getDefaultList();
                    setApiData(result); 
                }
            } catch (error) {
                // console.error("Error fetching data:", error);
            }
        };

        if (isTemplateId !== undefined || widgetId !== undefined) {
            fetchData();
        }
    }, [isTemplateId, widgetId, refreshWidgetList]);

    //Search Filter
    const filteredList = apiData?.data?.data_list?.filter((item) => {
    const searchLower = searchQuery.toLowerCase();
        return (
            item.question?.toLowerCase().includes(searchLower) ||
            item.answer?.toLowerCase().includes(searchLower)
        );
    });

    useEffect(() => {
        if (apiData?.data?.data_list?.length > 0) {
            if (Number(is_open_first_question_by_default) === 1) {
                setOpenIndexes([0]);
            }
        }
    }, [apiData, is_open_first_question_by_default]);


    const toggleAccordion = (index) => {
        if (Number(is_multiple_active_question) === 1) {
            setOpenIndexes(prevIndexes =>
                prevIndexes.includes(index)
                    ? prevIndexes.filter(i => i !== index)
                    : [...prevIndexes, index]
            );
        } else {
            setOpenIndexes(prevIndexes =>
                prevIndexes.includes(index) ? [] : [index]
            );
        }
    };


    return (
        <>
            <div className={`upgadeify faq_templates search-faq-temp ${is_website_frontend}`}>
                {apiData?.data?.data_list?.length > 0 ? (
                <>
                <div className='upgadeify-faq-temp-widget'>
                    <div className='upgadeify-faq-temp-header'>
                        {widget_title && (
                            <div className='upgadeify-faq-temp-title'>{widget_title}</div>
                        )}
                        {Number(is_open_search_bar) === 1 && (
                            <div className='upgadeify-faq-search'>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className='upgadeify-faq-search-bar-input'
                                    style={{ background: item_background_color }}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                {searchQuery ? (
                                    <span
                                        className='upgadeify-faq-search-clear-icon'
                                        onClick={() => setSearchQuery('')}
                                        style={{ cursor: 'pointer', marginLeft: '-25px' }}
                                    >
                                        {/* Cancel (X) Icon */}
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 6L6 18M6 6L18 18" stroke={question_text_color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </span>
                                ) : (
                                    <span className='upgadeify-faq-search-icon'>
                                        <svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3233 12.9048C15.5703 11.2971 16.158 9.27482 15.9668 7.24925C15.7757 5.22367 14.82 3.34701 13.2943 2.00104C11.7685 0.655069 9.78735 -0.0590965 7.75375 0.00383158C5.72015 0.0667597 3.7869 0.902055 2.34731 2.33978C0.906468 3.77851 0.068442 5.7125 0.00401015 7.74765C-0.0604217 9.78279 0.65359 11.7659 2.00054 13.2929C3.34749 14.8199 5.22601 15.7758 7.25329 15.9659C9.28056 16.1559 11.304 15.5658 12.9113 14.3158L12.9543 14.3608L17.1963 18.6038C17.2892 18.6967 17.3995 18.7704 17.5209 18.8207C17.6423 18.871 17.7724 18.8968 17.9038 18.8968C18.0352 18.8968 18.1653 18.871 18.2867 18.8207C18.4081 18.7704 18.5184 18.6967 18.6113 18.6038C18.7042 18.5109 18.7779 18.4006 18.8282 18.2792C18.8785 18.1578 18.9044 18.0277 18.9044 17.8963C18.9044 17.7649 18.8785 17.6348 18.8282 17.5134C18.7779 17.392 18.7042 17.2817 18.6113 17.1888L14.3683 12.9468L14.3233 12.9048ZM12.2473 3.75478C12.8119 4.31026 13.2609 4.97203 13.5685 5.70192C13.8761 6.43181 14.0361 7.21537 14.0393 8.0074C14.0425 8.79944 13.8889 9.58428 13.5873 10.3166C13.2857 11.049 12.8421 11.7144 12.282 12.2745C11.7219 12.8345 11.0565 13.2782 10.3242 13.5798C9.59181 13.8814 8.80697 14.035 8.01493 14.0318C7.2229 14.0286 6.43934 13.8686 5.70945 13.561C4.97956 13.2534 4.31779 12.8044 3.76231 12.2398C2.65223 11.1115 2.03297 9.59023 2.03941 8.0074C2.04586 6.42458 2.67749 4.90843 3.79672 3.78919C4.91596 2.66996 6.43211 2.03833 8.01493 2.03188C9.59775 2.02544 11.119 2.6447 12.2473 3.75478Z" fill={question_text_color}/>
                                        </svg>
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                    <div className='upgadeify-faq-temp-content'>
                        {Number(is_show_display_category_title) === 1 && (
                            <div className='upgadeify-faq-category-title'> All Questions </div>
                        )}
                        {sidebar_layout_type === 'Accordion' && filteredList.map((detail, index) => (
                            <div key={index} className='upgadeify-faq-temp'>
                            <div
                                className='upgadeify-faq-title'
                                style={{ background: item_background_color, cursor: 'pointer' }}
                                onClick={() => toggleAccordion(index)}
                            >
                                <div className='upgadeify-faq-question-title' style={{ color: question_text_color }}>{detail.question}</div>
                                <span className='upgadeify-faq-question-icon'>
                                    {accordion_icon_type === 'Plus' ? (
                                        openIndexes.includes(index) ? (
                                        // Cross Icon
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 6L6 18M6 6L18 18" stroke={question_text_color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        ) : (
                                        // Plus Icon
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 5V19M5 12H19" stroke={question_text_color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        )
                                    ) : (
                                        openIndexes.includes(index) ? (
                                            // Down Icon
                                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                                            <path d="M6 15L12 9L18 15" stroke={question_text_color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        ) : (
                                            // Up Icon
                                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                                            <path d="M6 9L12 15L18 9" stroke={question_text_color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        )
                                    )}
                                </span>
                            </div>
                            {openIndexes.includes(index) && (
                                <div className='upgadeify-faq-answer' style={{ color: answer_text_color }}>
                                    {detail.answer}
                                </div>
                            )}
                            </div>
                        ))}

                        {sidebar_layout_type === 'List' && filteredList.map((detail, index) => (
                            <div key={index} className='upgadeify-faq-temp'>
                                <div className='upgadeify-faq-title' style={{ background: item_background_color, cursor: 'pointer' }}>
                                    <div className='upgadeify-faq-question-title' style={{ color: question_text_color }}>{detail.question}</div>
                                </div>
                                <div className='upgadeify-faq-answer' style={{ color: answer_text_color }}>
                                    {detail.answer}
                                </div>
                            </div>
                        ))}

                        {sidebar_layout_type === 'Multicolumn' && (
                            <div className="upgadeify-multicolumn-faq-content">
                                {filteredList.map((detail, index) => (
                                    <div key={index} className='upgadeify-faq-temp multi-col-item'>
                                        <div className='upgadeify-faq-title' style={{ background: item_background_color, cursor: 'pointer' }}>
                                            <div className='upgadeify-faq-question-title' style={{ color: question_text_color }}>{detail.question}</div>
                                        </div>
                                        <div className='upgadeify-faq-answer' style={{ color: answer_text_color }}>
                                            {detail.answer}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                </>
                    ) : (
                        <div className="loader-container">
                            <div className="spinner"></div>
                            <p>Loading please wait...</p>
                        </div>
                    )}
            </div>
        </>
    );
};

export default CommonFaqTemplateWidget;
